<template>
    <el-dialog
        custom-class="user-org-dialog"
        title="选择流程"
        top="4vh"
        width="75%"
        :visible.sync="isInnerShow"
        append-to-body
      > 
        <el-container class="process-service-select">
              <el-aside width="200px">
                    <el-header height="35px">业务分类</el-header>
                    <BusinessTree
                        v-if="isShowTree"
                        :data="treeData"
                        :defaultProps="defaultProps"
                        @nodeClick="handleTreeNode"
                    />
              </el-aside>
              <el-main>
                  <el-container>
                      <el-aside style="width: 55%">
                          <div class="tools-bar">
                              <span><el-tag type="primary">流程方案列表</el-tag></span>
                              <div class="tools-search" @keyup.enter="handleSearchInDept">
                                  <el-input maxlength="100" v-model.trim="processServiceName" placeholder="流程方案名称">
                                      <el-button slot="append" icon="el-icon-search" @click="handleSearchInDept"></el-button>
                                  </el-input>
                              </div>
                          </div>
                          <template v-if="multiple">
                              <el-table  :data="processListInBusiness" @selection-change="handleSelectionChangeInDept" style="width: 100%" v-loading="inDpetloading" stripe>
                                  <el-table-column type="selection" width="55"></el-table-column>
                                  <el-table-column prop="serviceName" label="流程方案名称"></el-table-column>
                              </el-table>
                          </template>
                            <template v-else>
                                <el-table  :data="processListInBusiness" highlight-current-row @current-change="handleSelectionChangeInDept" style="width: 100%" v-loading="inDpetloading" stripe>
                                  <el-table-column prop="serviceName" label="流程方案名称"></el-table-column>
                                </el-table>
                            </template>
                          <!-- 分页 -->
                          <el-row type="flex" justify="end">
                              <el-pagination
                                  background
                                  layout="total, prev, pager, next"
                                  :total="totalPageNumInDept"
                                  :current-page="currentPageInDept"
                                  :page-size="pageSizeInDept"
                                  @current-change="queryFormDataInDept"
                                  >
                              </el-pagination>
                          </el-row>
                      </el-aside>
                      <el-aside style="width: 45%">
                          <div class="tools-bar">
                              <span><el-tag type="success">已选择的流程方案</el-tag></span>
                              <div class="tools-btn-group">
                                  <el-button icon="el-icon-remove" type="danger" @click="handleRemoveselectedProcessService">移除</el-button>
                              </div>
                          </div>
                          <el-table ref="multipleTable" :data="selectedProcessServiceList" @selection-change="handleSelectionRemovedUser" tooltip-effect="dark" style="width: 100%" v-loading="unInDpetloading" stripe>
                              <el-table-column type="selection" width="55"></el-table-column>
                              <el-table-column prop="serviceName" label="流程方案名称"></el-table-column>
                          </el-table>
                      </el-aside>
                  </el-container>            
              </el-main>
          </el-container>
          <span slot="footer" class="dialog-footer">
                <el-button @click="isInnerShow = false">取 消</el-button>
                <el-button type="primary" @click="confirmClick">确 定</el-button>
            </span>
      </el-dialog>
    
</template>

<script>
    import { getBusinessTreeList, getProcessServiceList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import Department from '@/components/Department';
    import { isEmpty } from 'lodash';
    export default {
        mixins: [ mixinsNav ],
        components: {
            Department: Department
        },
        data () {
            return {
                isInnerShow: false,
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                isShowTree: false,
                processServiceName: '', // 流程方案名称查询
                inDpetloading: false,
                processListInBusiness: [], // 所选业务分类下的流程方案列表
                currentPageInDept: 1, // 当前页码
                pageSizeInDept: 6, // 每页条数
                totalPageNumInDept: 1, // 总页数

                unInDpetloading: false,
                empNameUnInDept: '',
                selectedProcessServiceList: [], // 已选择的流程列表数据
                currentPageUnInDept: 1, // 当前页码
                pageSizeUnInDept: 6, // 每页条数
                totalPageNumUnInDept: 1, // 总页数

                selectMap: new Map(),
                currentBusinessId: '', // 当前点击的业务分类树
                selectedProcessServiceIds: '', // 选中的流程ID
                selectedProcessServiceNames: '', // 选中的流程方案名称
                selectedRemovedUserIds: ''// 选中的流程ID
            };
        },
        props: {
            selectedProcessService: {
                type: Object,
                default: function () {
                    return {
                        selectedProcessServiceIds: '',
                        selectedProcessServiceNames: ''
                    };
                }
            },
            isShowProcessServicePop: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false
            },
            maxItemsNum: {
                type: Number,
                default: 3
            }
        },
        created () {
            // this._initPage();
    
        },
        methods: {
            async _initPage () {
                // console.log(this.selectedProcessService);
                this.isInnerShow = this.isShowProcessServicePop;
                this.selectMap = new Map();
                if (!isEmpty(this.selectedProcessService.selectedProcessServiceIds)) {
                    this.selectedProcessServiceIds = this.selectedProcessService.selectedProcessServiceIds;
                    this.selectedProcessServiceNames = this.selectedProcessService.selectedProcessServiceNames;
                }
                // console.log("============"+this.selectedProcessServiceIds);
                this._getListData();
                this._getTreeData();
            },
            async _getListData () {
                await this.handleSearchInDept();
                await this.handleSearchUnInDept();
            },
            async _getTreeData () {
                let treeList = await getBusinessTreeList();
                this.treeData = treeList;
                this.isShowTree = true;
            },
            handleTreeNode (data, node, tree) {
                this.currentBusinessId = data.id;
                this.currentPageInDept = 1;
                this.handleSearchInDept();
                // 初始化变量
                // this.selectedProcessServiceIds = '';
                // this.selectedRemovedUserIds = '';
            },
            async handleSearchInDept () {
                this.inDpetloading = true;
                let processListData = await getProcessServiceList({
                    pageSize: this.pageSizeInDept,
                    currentPage: this.currentPageInDept,
                    serviceName: this.processServiceName,
                    serviceType: this.currentBusinessId,
                    state: 1 // 0:草稿 1:已发布 2:已删除
                });
                // console.log(filterProcess);
                this.processListInBusiness = processListData.data;
                this.currentPageInDept = processListData.currentPage;
                this.pageSizeInDept = processListData.pageSize;
                this.totalPageNumInDept = processListData.totalPageNum;
                this.inDpetloading = false;
            },
            queryFormDataInDept (currentPageInDept) {
                this.currentPageInDept = currentPageInDept;
                this._getListData();
            },
            async handleSearchUnInDept () {
                // console.log(this.selectedProcessServiceIds);
                this.unInDpetloading = true;
                if (!isEmpty(this.selectedProcessServiceIds)) {
                    let ids = this.selectedProcessServiceIds.split(',');
                    let serviceNames = this.selectedProcessServiceNames.split(',');
                    let selectedData = [];
                    for (var i = 0; i < ids.length; i++) {
                        selectedData.push({id: ids[i], serviceName: serviceNames[i]});
                    }
                    this.selectedProcessServiceList = selectedData;
                } else {
                    this.selectedProcessServiceList = [];
                }
                this.unInDpetloading = false;
            },
            queryFormDataUnInDept (currentPageUnInDept) {
                this.currentPageUnInDept = currentPageUnInDept;
                this._getListData();
            },
            async handleRemoveselectedProcessService () {
                if (!isEmpty(this.selectedRemovedUserIds)) {
                    let newIds = this.selectedRemovedUserIds.split(',');
                    let ids = this.selectedProcessServiceIds.split(',');
                    let serviceNames = this.selectedProcessServiceNames.split(',');
                    let selectedData = [];
                    this.selectedProcessServiceIds = '';
                    this.selectedProcessServiceNames = '';
                    let removedMap = new Map();
                    for (var j = 0; j < newIds.length; j++) {
                        removedMap.set(newIds[j], newIds[j]);
                    }
                    for (var i = 0; i < ids.length; i++) {
                        if (!removedMap.has(ids[i])) {
                            selectedData.push({id: ids[i], serviceName: serviceNames[i]});
                            if (isEmpty(this.selectedProcessServiceIds)) {
                                this.selectedProcessServiceIds = ids[i];
                                this.selectedProcessServiceNames = serviceNames[i];
                            } else {
                                this.selectedProcessServiceIds = this.selectedProcessServiceIds + ',' + ids[i];
                                this.selectedProcessServiceNames = this.selectedProcessServiceNames + ',' + serviceNames[i];
                            }
                        } else {
                            this.selectMap.delete(ids[i]);
                        }
                    }
                    this.selectedProcessServiceList = selectedData;
                    // this.selectedProcessService.selectedProcessServiceIds = this.selectedProcessServiceIds;
                    // this.selectedProcessService.selectedProcessServiceNames = this.selectedProcessServiceNames;
                }
            },
            handleSelectionChangeInDept (rows) {
                // this.selectedProcessServiceIds = '';
                // this.selectedProcessServiceNames = '';
                if (rows) {
                    if (Array.isArray(rows)) {
                        rows.forEach(row => {
                            if (row) {
                                if (!this.selectMap.has(row.id)) {
                                    if (isEmpty(this.selectedProcessServiceIds)) {
                                        this.selectedProcessServiceIds = row.id;
                                        this.selectedProcessServiceNames = row.serviceName;
                                    } else {
                                        this.selectedProcessServiceIds = this.selectedProcessServiceIds + ',' + row.id;
                                        this.selectedProcessServiceNames = this.selectedProcessServiceNames + ',' + row.serviceName;
                                    }
                                    this.selectMap.set(row.id, row.id);
                                }
                            }
                        });
                    } else {
                        this.selectedProcessServiceIds = rows.id;
                        this.selectedProcessServiceNames = rows.serviceName;
                    }
                    this.handleSearchUnInDept();
                }
            },
            handleSelectionRemovedUser (rows) {
                this.selectedRemovedUserIds = '';
                if (rows) {
                    rows.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedRemovedUserIds)) {
                                this.selectedRemovedUserIds = row.id;
                            } else {
                                this.selectedRemovedUserIds = this.selectedRemovedUserIds + ',' + row.id;
                            }
                        }
                    });
                }
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            confirmClick () {
                this.selectedProcessService.selectedProcessServiceIds = this.selectedProcessServiceIds;
                this.selectedProcessService.selectedProcessServiceNames = this.selectedProcessServiceNames;
                let arr = this.selectedProcessService.selectedProcessServiceIds.split(',');
                if (arr.length > this.maxItemsNum) {
                    this.messageTip('最多只能选择' + this.maxItemsNum + '条流程方案', 'warning');
                    return false;
                }
                // console.log(this.selectedProcessService);
                this.$emit('nodeClick', this.selectedProcessService);
                this.isInnerShow = false;
            }
        }
    };
</script>

<style lang="less">
    .process-service-select {
        height: 365px;
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ProcessServiceSelectPop/ProcessServiceSelectPop.vue